import { render, staticRenderFns } from "./WelfarePopup.vue?vue&type=template&id=3403d85b&scoped=true&"
import script from "./WelfarePopup.vue?vue&type=script&lang=js&"
export * from "./WelfarePopup.vue?vue&type=script&lang=js&"
import style0 from "./WelfarePopup.vue?vue&type=style&index=0&id=3403d85b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403d85b",
  null
  
)

export default component.exports